<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div class="sidebar">
  <div class="menu">
      <mat-nav-list appAccordion>
          <div *ngFor="let item of menuItems.getMenuitem()">
            <mat-list-item appAccordionLink (click)="onItemSelected(item)" 
                [ngClass]="{'selected': item.route ? router.isActive(item.route, true): false}">
                    <a class="" appAccordionToggle>
                        <mat-icon [matTooltip]="item.displayName">{{ item.iconName }}</mat-icon> {{ item.displayName}}
                        <span fxFlex></span>
                    </a>
            </mat-list-item>
        </div>
      </mat-nav-list>
  </div>
</div>
